import React from "react";
import {
  Drawer,
  List,
  Divider,
  IconButton,
  useMediaQuery,
  useTheme,
  Box,
  Typography,
} from "@mui/material";
import { ChevronLeft as ChevronLeftIcon } from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import { NavigationItem } from "./NavigationItem";
import { DrawerHeader } from "./styles";
import { drawerWidth, menuItems } from "./constants";

interface SideNavProps {
  open: boolean;
  onDrawerClose: () => void;
}

export const SideNav: React.FC<SideNavProps> = ({ open, onDrawerClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();

  return (
    <Drawer
      variant={isMobile ? "temporary" : "persistent"}
      anchor="left"
      open={open}
      onClose={isMobile ? onDrawerClose : undefined}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
        },
      }}
    >
      <DrawerHeader>
        <IconButton onClick={onDrawerClose}>
          <ChevronLeftIcon />
        </IconButton>
      </DrawerHeader>
      <Divider />
      <List>
        {menuItems.map((item) => (
          <NavigationItem
            key={item.text}
            text={item.text}
            icon={item.icon}
            path={item.path}
            selected={location.pathname.startsWith(item.path)}
          />
        ))}
      </List>
      <Box sx={{ mt: "auto", p: 2, textAlign: "center" }}>
        <Typography variant="caption" color="text.secondary">
          Stratify Beta v{import.meta.env.VITE_APP_VERSION}
        </Typography>
      </Box>
    </Drawer>
  );
};
